import {
    useCheckOrganizationInvitesMutation,
    useInviteMemberMutation,
} from "@api/workspaceMember.api";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { OrganizationIdNameLogoUrl } from "@common/schemas/organization.schema";
import {
    buildInviteMemberPayload,
    getInviteSentMessage,
} from "./inviteMember.utils";
import { AddMemberFormSchema } from "./types";

interface UseInviteMemberWithOrganizationCheckParams {
    workspaceId?: string;
    onInvited?: () => void;
    onAfterDirectInvite?: () => void;
    onOrganizationsFound: (args: {
        organizations: OrganizationIdNameLogoUrl[];
        confirmInvite: () => Promise<void>;
    }) => void;
}

export function useInviteMemberWithOrganizationCheck({
    workspaceId,
    onInvited,
    onAfterDirectInvite,
    onOrganizationsFound,
}: UseInviteMemberWithOrganizationCheckParams) {
    const { toast } = useToaster();
    const inviteMemberMutation = useInviteMemberMutation(workspaceId);
    const checkOrganizationInvitesMutation =
        useCheckOrganizationInvitesMutation(workspaceId);

    const handleSubmit = async (value: AddMemberFormSchema): Promise<void> => {
        const confirmInvite = async () => {
            await inviteMemberMutation.mutateAsync(
                buildInviteMemberPayload(value),
            );
            onInvited?.();
            toast(getInviteSentMessage(value.emails));
        };

        const organizations =
            await checkOrganizationInvitesMutation.mutateAsync(value.emails);

        if (!organizations.length) {
            await confirmInvite();
            onAfterDirectInvite?.();
            return;
        }

        onOrganizationsFound({
            organizations,
            confirmInvite,
        });
    };

    return {
        handleSubmit,
    };
}
